require('./_wks-define')('asyncIterator');


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 888
// module chunks = 0